import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import PopupAlert from "../../components/PopupAlert";

const EmailAlert = () => {
  const { loginWithRedirect } = useAuth0();
  const [open, setOpen] = useState(true);

  const title ='Registration Successful!'
  const message = "We have sent a confirmation email to your registered address. Please confirm your email to proceed "
  
  const handlebacktoLogin =()=>{
    setOpen(false);
    loginWithRedirect()
  }


  return (
    <>
    <PopupAlert open={open} handleClose={handlebacktoLogin} message={message} title={title} buttonText={"Back to login"}/>
    </>
  );
};
export default EmailAlert;